import styled from 'styled-components';
import DivisionLine from 'ggApp/shared/components/layout/divisionLine';

export const Form = styled.form`
    label {
        ${({ theme }) => theme.typography.SmallCapsHeadline};
        color: ${({ theme }) => theme.colors.Foreground};
    }
`;

export const Section = styled.section`
    margin-top: 24px;
`;

export const SectionText = styled.div`
    ${({ theme }) => theme.typography.Paragraph}
    color: ${({ theme }) => theme.colors['Level 5']};
    margin: 16px 0;
`;

export const DivisionLabel = styled(DivisionLine)`
    ${({ theme }) => theme.typography.SmallCapsHeadline};
`;

export const Container = styled.div`
    display: inline-flex;
    cursor: pointer;
    user-select: none;
    align-items: center;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    opacity: ${({ disabled }) => disabled ? 0.5 : 1 };
`;

export const TextTypography = styled.p`
    ${({ theme }) => theme.typography.SmallCapsHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-left: 16px;
`;
